<template>
  <div class="fixed top-0 h-16 w-full text-center border-b bg-white z-50">
    <div class="fixed pl-2 pt-2 cursor-pointer" @click="top()">
      <img :src="require('@/assets/images/jre-mark.jpeg')" class="w-16">
    </div>
    <div class="font-bold text-2xl pt-4">改定前後運賃検索サイト</div>
  </div>
</template>

<script>
export default {
  methods: {
    top: function () {
      window.location.href = 'https://www.jreast.co.jp/';
    }
  }
}
</script>
